/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]'
};
const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
  controls: 'aria-controls'
};
class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    try {
      this._setupCountries();
    } catch (e) {
      console.warn('Country/Province setup skipped:', e);
    }
    this._setupEventListeners();
  }
  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container ? {
      container,
      addressContainer: container.querySelector(selectors.addressContainer),
      toggleButtons: container.querySelectorAll(selectors.toggleAddressButton),
      cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
      deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
      countrySelects: container.querySelectorAll(selectors.addressCountrySelect)
    } : {};
  }
  _getControlledSection(controllerBtn) {
    const id = controllerBtn.getAttribute(attributes.controls);
    return id ? document.getElementById(id) : null;
  }
  _setupCountries() {
    if (typeof Shopify === 'undefined' || !Shopify.CountryProvinceSelector) return;
    const wireForm = formEl => {
      if (!formEl) return;
      const country = formEl.querySelector('select[name="address[country]"]');
      const province = formEl.querySelector('select[name="address[province]"]');
      const provinceContainer = formEl.querySelector('[id^="AddressProvinceContainer"]') || formEl.querySelector('[data-address-province-wrapper]');
      if (!country || !province) return;
      if (!country.id) country.id = `AddressCountry_${Math.random().toString(36).slice(2)}`;
      if (!province.id) province.id = `AddressProvince_${Math.random().toString(36).slice(2)}`;
      new Shopify.CountryProvinceSelector(country.id, province.id, {
        hideElement: provinceContainer && provinceContainer.id ? provinceContainer.id : undefined
      });
    };
    const newForm = this.elements.container.querySelector('#AddAddress form');
    wireForm(newForm);
    this.elements.container.querySelectorAll('[id^="EditAddress_"] form').forEach(wireForm);
  }
  _setupEventListeners() {
    this.elements.toggleButtons.forEach(element => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach(element => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach(element => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }
  _toggleExpanded(targetBtn, force) {
    const current = targetBtn.getAttribute(attributes.expanded) === 'true';
    const next = typeof force === 'boolean' ? force : !current;
    targetBtn.setAttribute(attributes.expanded, String(next));
    const controlled = this._getControlledSection(targetBtn);
    if (controlled) controlled.hidden = !next;
  }
  _handleAddEditButtonClick = ({
    currentTarget
  }) => {
    this._toggleExpanded(currentTarget);
  };
  _handleCancelButtonClick = ({
    currentTarget
  }) => {
    const wrapper = currentTarget.closest(selectors.addressContainer);
    if (!wrapper) return;
    const controlledBlock = currentTarget.closest('#AddAddress, [id^="EditAddress_"]');
    if (controlledBlock) {
      controlledBlock.hidden = true;
      const controller = wrapper.querySelector(`[${attributes.controls}="${controlledBlock.id}"]`);
      if (controller) this._toggleExpanded(controller, false);
      const form = controlledBlock.querySelector('form');
      if (form) form.reset();
    }
  };
  _handleDeleteButtonClick = ({
    currentTarget
  }) => {
    const msg = currentTarget.getAttribute(attributes.confirmMessage) || 'Supprimer cette adresse ?';
    if (!confirm(msg)) return;
    const url = currentTarget.dataset.target;
    if (!url) return;
    if (typeof Shopify !== 'undefined' && typeof Shopify.postLink === 'function') {
      Shopify.postLink(url, {
        parameters: {
          _method: 'delete',
          form_type: 'customer_address'
        }
      });
      return;
    }
    const form = document.createElement('form');
    form.method = 'post';
    form.action = url;
    const methodInput = document.createElement('input');
    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'delete';
    form.appendChild(methodInput);
    const formType = document.createElement('input');
    formType.type = 'hidden';
    formType.name = 'form_type';
    formType.value = 'customer_address';
    form.appendChild(formType);
    const utf8 = document.createElement('input');
    utf8.type = 'hidden';
    utf8.name = 'utf8';
    utf8.value = '✓';
    form.appendChild(utf8);
    document.body.appendChild(form);
    form.submit();
  };
}
document.addEventListener('DOMContentLoaded', function () {
  if (typeof CustomerAddresses !== 'undefined') new CustomerAddresses();
  document.querySelectorAll('.toggle-password').forEach(button => {
    button.addEventListener('click', () => {
      const input = document.getElementById(button.dataset.target);
      if (!input) return;
      const isPassword = input.getAttribute('type') === 'password';
      input.setAttribute('type', isPassword ? 'text' : 'password');
      const svg = button.querySelector('svg');
      if (!svg) return;
      svg.querySelectorAll('.eye-open').forEach(el => el.style.display = isPassword ? 'none' : 'inline');
      svg.querySelectorAll('.eye-closed').forEach(el => el.style.display = isPassword ? 'inline' : 'none');
    });
  });
  const form = document.querySelector('form');
  const password = document.getElementById('RegisterForm-password');
  const confirmation = document.getElementById('RegisterForm-password-confirmation');
  const errorMsg = document.getElementById('PasswordConfirmationError');
  function checkPasswordsMatch() {
    if (!password || !confirmation || !errorMsg) return true;
    const match = password.value === confirmation.value;
    if (!match && confirmation.value.length > 0) {
      errorMsg.style.display = 'flex';
      confirmation.classList.add('invalid');
      confirmation.setAttribute('aria-invalid', 'true');
    } else {
      errorMsg.style.display = 'none';
      confirmation.classList.remove('invalid');
      confirmation.removeAttribute('aria-invalid');
    }
    return match;
  }
  if (confirmation) confirmation.addEventListener('input', checkPasswordsMatch);
  if (password) password.addEventListener('input', checkPasswordsMatch);
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!checkPasswordsMatch()) {
        e.preventDefault();
        confirmation && confirmation.focus();
      }
    });
  }
});
/******/ })()
;